import RequireAuth from '@converge/ui/domain/auth/require-auth';
import { ProducerGrid } from '@converge/ui';

export const ProducersPage = () => {
  return (
    <RequireAuth>
      <ProducerGrid />
    </RequireAuth>
  );
};

export default ProducersPage;
